import React, { useState, useEffect } from "react";
import MainNavLinks from "./MainNav";
import { isTelegramWebApp } from "../Utils/utils";

const LeftSideDesktopNav = () => {
    const [expandMenuClass, setExpandMenuClass] = useState(localStorage.getItem('navClass') || '');
    const [height, setHeight] = useState('');
    const mouseOver = () => {
        setExpandMenuClass('expand-left-nav');
    }
    const mouseOut = () => {
        let rootEl = document.getElementById('root');
        if(rootEl && rootEl.className.indexOf('sgt-menu-open') !== -1    ) {
            setExpandMenuClass('expand-left-nav');
        }
        else {
            setExpandMenuClass('');
        }
    }

    const adjustHeight = () => {
        if(window.innerWidth  > 900) {
            var x = 0;
            var intervalID = setInterval(function () {
                const documentHeight = document.body.scrollHeight / 0.8;
                setHeight(documentHeight);
                console.log("doc h: ", documentHeight)
                if (++x === 5) {
                    window.clearInterval(intervalID);
                }
            }, 1000);
        }
    }

    useEffect(() => {
        adjustHeight();
    }, [])

    // if(isTelegramWebApp()) {   
    //     return (
    //         <div className="t-shillgard-logo">
    //             <a href="/"></a>
    //         </div>
    //     );
    // }

    return (
        <div 
            className={`desktop-nav left-side-nav ${expandMenuClass}`} 
            onMouseOver={mouseOver} 
            onMouseLeave={mouseOut}
            style={height && height !== "" ? {"height" : `${height}px`} : {}}
        >
            {/* <button className="sc-guDLey kLTlmV burger-btn"><div></div><div></div></button> */}
            {/* <div className="flex-box"><span>ShillGuard</span></div> */}
            <MainNavLinks />
        </div>
    )
}

export default LeftSideDesktopNav;